import CustomViewOptionCustomSection from "csi/middleware/customView/options/CustomViewOptionCustomSection";
import { isDefined } from "csi/utility/coreUtility";
import { Box, FlexColumn, FlexRow, OverflowText, SingleSelect } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import CheckboxOption from "./CheckboxOption";
import css from "./CustomViewOptions.module.css";
import PropertyCustomViewOptionsStore from "./PropertyCustomViewOptionsStore";
import PropertyPrintOptions from "./PropertyPrintOptions";
import SelectOption from "./SelectOption";

const PropertyOptionsTab: FunctionComponent = observer(function PropertyOptionsTab() {
	const { optionsStore } = useCustomViewDialogStore();

	const {
		hasPrintOptions,
		options,
		printOptionsCollapse,
		propertyDropDownOptions,
		selectedPropertyColumn,
		selectedPropertyImageLabel,
		selectedImageSizes,
		setDisplayPropertyImage,
		setImageLabel,
		setImageSize,
		setPropertyColumns,
		setShowFileSizes,
		setShowThumbnailLabel,
		toggleCollapsedPrintOptions,
		toggleCollapsedViewMainOptions,
		viewMainOptionsCollapse,
	} = optionsStore as PropertyCustomViewOptionsStore;

	const {
		imageLabels,
		imageSizes,
		propertyColumns,
	} = propertyDropDownOptions;

	const {
		displayPropertyImage,
		propertyColumns: propertyColumn,
		propertyImageLabel,
		propertyShowThumbnailLabel,
		showFileSizes,
	} = options;

	return (
		<FlexColumn>
			{/* properties options */}
			<CustomViewOptionCustomSection
				collapsed={viewMainOptionsCollapse}
				dataCsiAutomation="PropertyOptionsTab"
				onCollapse={toggleCollapsedViewMainOptions}
				titleRes="CustomViewPropertyOptions"
			>
				<FlexRow className={css.container}>
					<OverflowText
						className={css.sectionTitle}
						res="CustomViewDisplayOptionsAppearance"
					/>
				</FlexRow>
				<CheckboxOption
					dataCsiAutomation="CustomViewPropertyDisplayImageGallery"
					label="CustomViewPropertyDisplayImageGallery"
					onChange={setDisplayPropertyImage}
					optionValue={displayPropertyImage}
					paddingLeft={0}
				/>
				{isDefined(propertyImageLabel) && displayPropertyImage && (
					<SelectOption
						dataCsiAutomation="CustomViewGalleryCoverImage"
						res="CustomViewGalleryCoverImage"
						selectProps={{
							onChange: setImageLabel,
							options: imageLabels,
							grouped: true,
							sx: { paddingLeft: 6 },
							value: selectedPropertyImageLabel,
						}}
					/>
				)}
				{displayPropertyImage && (
					<CheckboxOption
						dataCsiAutomation="CustomViewPropertyShowThumbnailLabels"
						label="CustomViewPropertyShowThumbnailLabels"
						onChange={setShowThumbnailLabel}
						optionValue={propertyShowThumbnailLabel}
						paddingLeft={6}
					/>
				)}
				{isDefined(propertyColumn) && (
					<SelectOption
						dataCsiAutomation="CustomViewPropertyNumberPropertyColumns"
						res="CustomViewPropertyNumberPropertyColumns"
						selectProps={{
							onChange: setPropertyColumns,
							options: propertyColumns,
							value: selectedPropertyColumn,
						}}
					/>
				)}
				{isDefined(selectedImageSizes) && (
					<Box className={css.galleryContainer}>
						<FlexRow>
							<FlexColumn
								className={css.optionLeft}
								data-csi-automation="CustomViewPropertyImageSize"
							>
								<SingleSelect
									disableClearable
									fullWidth
									labelRes="CustomViewPropertyImageSize"
									onChange={setImageSize}
									options={imageSizes}
									value={selectedImageSizes}
								/>
							</FlexColumn>
						</FlexRow>
					</Box>
				)}
				<FlexRow className={css.container}>
					<OverflowText
						className={css.sectionTitle}
						res="CustomViewAdvancedOptions"
					/>
				</FlexRow>
				<CheckboxOption
					dataCsiAutomation="CustomViewShowFileSizes"
					label="CustomViewShowFileSizes"
					onChange={setShowFileSizes}
					optionValue={showFileSizes}
					paddingLeft={0}
				/>
			</CustomViewOptionCustomSection>
			{hasPrintOptions && (
				<CustomViewOptionCustomSection
					collapsed={printOptionsCollapse}
					onCollapse={toggleCollapsedPrintOptions}
					titleRes="CustomViewPrintOptions"
				>
					<PropertyPrintOptions />
				</CustomViewOptionCustomSection>
			)}
		</FlexColumn>
	);
});

export = PropertyOptionsTab;